import "./IconErrorCircle.scss";
import { ReactComponent as CircleError } from "./svg/icon-error-circle.svg";

export const IconErrorCircle = ({ id = "" }: { id?: string }) => {
  return (
    <span id={id} className="icon-error-circle">
      <CircleError />
    </span>
  );
};
